import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cheese"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 9L11.0807 6.13242C11.3608 7.20692 12.3378 8 13.5 8C14.8807 8 16 6.88071 16 5.5C16 5.1934 15.9448 4.89969 15.8438 4.62827L21 3L17.8351 13.0223C17.7255 13.0076 17.6136 13 17.5 13C16.1193 13 15 14.1193 15 15.5C15 16.4666 15.5485 17.305 16.3513 17.721L15 22L14.243 21.8198C8.28984 20.4023 3.60612 15.7457 2.18869 9.7925L2 9Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 12.5C12 13.8807 10.8807 15 9.5 15C8.11929 15 7 13.8807 7 12.5C7 11.1193 8.11929 10 9.5 10C10.8807 10 12 11.1193 12 12.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 9L11.0807 6.13242C11.3608 7.20692 12.3378 8 13.5 8C14.8807 8 16 6.88071 16 5.5C16 5.1934 15.9448 4.89969 15.8438 4.62827L21 3L17.8351 13.0223C17.7255 13.0076 17.6136 13 17.5 13C16.1193 13 15 14.1193 15 15.5C15 16.4666 15.5485 17.305 16.3513 17.721L15 22L14.243 21.8198C8.28984 20.4023 3.60612 15.7457 2.18869 9.7925L2 9Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 12.5C12 13.8807 10.8807 15 9.5 15C8.11929 15 7 13.8807 7 12.5C7 11.1193 8.11929 10 9.5 10C10.8807 10 12 11.1193 12 12.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const Cheese = Vue.extend<IconProps>({
  name: 'CheeseIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cheese',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cheese;
